// extracted by mini-css-extract-plugin
module.exports = {"root":"faq_root__thTGW","headingContainer":"faq_headingContainer__RBopR","heading":"faq_heading__v5_yF","item":"faq_item__MbOoa","paragraph":"faq_paragraph__7hl1c"};